export var SecuritySendYourDataTestSubject;
(function (SecuritySendYourDataTestSubject) {
    SecuritySendYourDataTestSubject["SendYourDataPage"] = "send-your-data-page";
    SecuritySendYourDataTestSubject["SendYourDataInstructions"] = "send-your-data-instructions";
})(SecuritySendYourDataTestSubject || (SecuritySendYourDataTestSubject = {}));
//# sourceMappingURL=security-send-your-data.enum.js.map